var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C198ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2704)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1329 50.6829C52.2712 43.5798 53.5895 31.4355 44.596 23.1301C37.7223 16.7838 19.1525 16.1431 12.6928 29.9854C11.6144 32.2951 13.0883 35.9178 15.9886 35.7859C17.1276 35.7332 17.8342 39.3454 18.4934 41.5865C17.5706 50.6829 9.34956 50.8516 5.17842 57.8017C0.0370074 66.3708 6.3649 79.0266 21.5255 79.0266C36.6861 79.0266 45.3764 66.4762 50.1329 50.6829Z",
    fill: "url(#paint0_linear_1_2704)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.274 71.3804C57.2067 75.0717 58.1743 104.772 58.1743 104.772H3.85986C3.85986 104.772 4.8275 75.0717 6.76015 71.3804C9.66044 65.8435 31.0171 58.7246 31.0171 58.7246C31.0171 58.7246 52.3737 65.8435 55.274 71.3804Z",
    fill: "url(#paint1_linear_1_2704)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3452 61.8886C37.3452 61.8886 33.9809 63.7342 30.8829 63.7342C27.7848 63.7342 24.6894 61.8886 24.6894 61.8886V56.088C24.0234 56.1924 23.3488 56.2322 22.6751 56.2067C16.3472 56.2067 13.9742 46.9943 15.1976 35.786C15.9886 35.786 17.8342 35.786 20.4708 32.0947C19.8117 37.2361 27.4579 36.4452 30.3582 32.3584C28.908 37.2361 32.7311 40.5319 36.0269 38.5545C42.4893 34.676 43.9368 46.4986 37.3452 46.5962V61.8886Z",
    fill: "url(#paint2_linear_1_2704)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6895 56.0878C27.9601 55.4856 31.0898 54.2785 33.9176 52.5283C33.9176 52.5283 30.6219 58.1971 24.6895 58.1971V56.0878Z",
    fill: "#FFB597"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0253 63.4705C32.9315 63.3862 37.3532 62.4528 37.3532 60.4358V58.7246C37.8383 58.7246 39.2225 59.8663 39.9344 60.8339C42.7477 64.657 39.6259 68.0846 37.0789 68.0846C33.8675 68.0846 31.7371 65.4005 31.0147 64.1086C30.3028 65.4005 28.1751 68.0846 24.9505 68.0846C22.4035 68.0846 19.2817 64.657 22.0976 60.8339C22.8095 59.8663 24.2069 58.7246 24.6763 58.7246V60.4279C24.6763 62.4449 29.2086 63.3782 31.0041 63.4626L31.0253 63.4705Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2423 57.7784V61.0971C77.2423 65.5219 83.603 67.4578 83.603 67.4578C83.603 67.4578 76.2744 72.9888 68.6692 72.9888C61.064 72.9888 53.7354 67.4578 53.7354 67.4578C53.7354 67.4578 60.1458 65.5219 60.0961 61.0971C60.0463 56.6722 60.0794 54.0726 60.0463 46.4923C56.0833 41.354 56.3377 37.9192 58.5059 35.4828C65.7654 27.3577 85.5389 30.1232 85.5389 30.1232C85.5389 30.1232 87.3835 50.035 83.1882 55.8426C81.3906 58.3316 77.2423 57.7784 77.2423 57.7784Z",
    fill: "url(#paint3_linear_1_2704)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2423 57.7785C71.1582 57.0871 67.563 54.4598 67.563 54.4598C69.8327 57.818 73.2919 60.19 77.2423 61.0971V57.7785Z",
    fill: "#9C3A0D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.459 38.2013C62.5795 37.4463 61.5231 36.9374 59.9993 37.7228C56.4041 39.5813 59.1281 46.7163 62.3085 46.7163C63.1382 46.7163 63.5502 49.3214 59.8582 51.1411C59.8582 48.2373 55.4334 41.047 55.0462 34.501C50.5937 32.8417 51.6999 26.2044 54.7558 26.2044C54.2691 20.1203 64.0065 16.9814 67.7759 20.4715C71.6117 15.8752 81.2911 18.2259 81.8801 22.2138C88.5367 18.6601 92.9118 28.8731 86.6783 32.8389C84.1146 34.4678 78.1052 35.09 69.4546 35.09C68.1493 35.09 67.4164 35.4136 67.7953 37.0259C68.4839 40.1703 66.8412 42.1421 63.459 38.2013Z",
    fill: "url(#paint4_linear_1_2704)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7949 76.002C99.3716 81.5367 100.855 101.994 100.855 101.994H35.8975C35.8975 101.994 37.3813 81.5353 39.9573 76.002C42.5333 70.4686 57.5768 65.3363 57.5768 65.3363C60.4764 71.6263 76.3896 71.6256 79.1673 65.3344C79.1673 65.3344 94.2182 70.4672 96.7949 76.002Z",
    fill: "url(#paint5_linear_1_2704)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 64,
    width: 66,
    height: 31
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6494 74.2001C100.226 79.4391 101.709 94.1554 101.709 94.1554H36.752C36.752 94.1554 38.2358 79.4378 40.8118 74.2001C43.3878 68.9624 58.4312 64.1044 58.4312 64.1044C61.3309 70.0583 77.2441 70.0576 80.0218 64.1025C80.0218 64.1025 95.0727 68.9611 97.6494 74.2001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1909 76.0259H103.561V78.1911H33.1909V76.0259ZM33.191 81.4391H103.561V83.6043H33.191V81.4391ZM103.561 86.8518H33.191V89.017H103.561V86.8518Z",
    fill: "#FFA789"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2704",
    x1: 27.5581,
    y1: 79.0266,
    x2: 27.5581,
    y2: 18.8034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2704",
    x1: 31.0171,
    y1: 88.5184,
    x2: 31.0171,
    y2: 58.7246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2704",
    x1: 28.2621,
    y1: 32.0947,
    x2: 28.2621,
    y2: 63.7342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2704",
    x1: -42544.4,
    y1: 56536.6,
    x2: -42544.4,
    y2: 49712.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB6827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7551B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2704",
    x1: -49547,
    y1: 44691.3,
    x2: -49547,
    y2: 40708.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A182F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2704",
    x1: 100.855,
    y1: 94.3018,
    x2: 100.855,
    y2: 65.3344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.9cb012e9bd2717369a1174f6572dd63a.svg";
export { ForwardRef as ReactComponent };